import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Lang from "../../userPreferences/staticWords";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import { styleEnd } from "../../algorithms/styleDirection";
import Button from "../sharedComponents/buttons/button";
import DateInput from "../sharedComponents/datesInputs/date";
import { useDispatch, useSelector } from "react-redux";
import { addAssignmentCommentAPI } from "../../API/store/actions/PresidentialAssignmenty";
import { addSubTaskResponseAPI } from "../../API/store/actions/SubPresidentalAssignment";
import { useParams } from "react-router-dom";

const ResponseForm = (props) => {
  const { show, setShow, isEdit, onSuccess, assignment, isSubAssignment } =
    props;
  const id = useParams().id;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [title, setTitle] = useState("");
  const [responseDate, setResponseDate] = useState(new Date());
  const [attachments, setAttachments] = useState([]);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.login.userToken);
  const user = useSelector((state) => state.login.userData);
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = {};

    if (!title.trim()) {
      validationErrors.title = "موضوع الرد مطلوب";
    }

    // if (!responseDate) {
    //   validationErrors.responseDate = "تاريخ الرد مطلوب";
    // }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    setIsSubmitting(true);

    setIsSubmitting(true);

    try {
      const formData = new FormData();

      // formData.append("Id", 0);

      formData.append("Description", title);
      if (!isSubAssignment)
        formData.append("ExpPresidentialTasksId", assignment.id);
      // if (id) formData.append("taskprocedureId", id);

      attachments.forEach((file) => {
        formData.append(
          isSubAssignment ? "AttachmentFile" : "Attachment",
          file,
        );
      });

      const action = isSubAssignment
        ? await addSubTaskResponseAPI(
            user?.id,
            assignment.id,
            formData,
            userToken,
          )
        : await addAssignmentCommentAPI(user?.id, formData, userToken);

      const result = await dispatch(action);

      if (!result.error) {
        onSuccess?.();

        setTitle("");
        setResponseDate(new Date());
        setAttachments([]);

        setErrors({});
        setShow(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    if (!show) {
      setErrors({});
    }
  }, [show]);
  const handleFilesChange = (e) => {
    setAttachments(Array.from(e.target.files));
  };
  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledsby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "white",
                height: 25,
                width: 30,
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center px-1 mt-1"
            >
              <img
                src={"/assets/policy-green.svg"}
                width={25}
                height={25}
                alt=""
              />
            </div>{" "}
            <div className="text-dark">
              <p
                className="my-0 mx-1"
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "rgb(12, 87, 76)",
                }}
              >
                {!isEdit ? Lang.addResponse : Lang.editResponse}
              </p>
            </div>
          </div>
        </Modal.Title>{" "}
        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"rgb(12, 87, 76)"}
            onclick={() => setShow(false)}
          />
        </div>
      </Modal.Header>
      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Response Subject */}
            <div className="col-12 mb-3">
              <label className="form-label">موضوع الرد</label>
              <textarea
                className="form-control"
                rows={4}
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);

                  if (errors.title) {
                    setErrors((prev) => ({ ...prev, title: "" }));
                  }
                }}
                placeholder="أدخل موضوع الرد"
              />{" "}
              {errors.title && (
                <div className="invalid-feedback d-block">{errors.title}</div>
              )}
            </div>

            {/* Response Date */}
            {/* <div className="col-md-6 mb-3">
              <label className="form-label">تاريخ الرد</label>
              <DateInput
                value={responseDate}
                onChange={(date) => {
                  setResponseDate(date);

                  if (errors.responseDate) {
                    setErrors((prev) => ({ ...prev, responseDate: "" }));
                  }
                }}
              />{" "}
              {errors.responseDate && (
                <div className="text-danger mt-1">{errors.responseDate}</div>
              )}
            </div> */}

            {/* Attachments */}
            <div className="col-md-12 mb-3">
              <label className="form-label">المرفق</label>
              <input
                type="file"
                className="form-control"
                onChange={handleFilesChange}
              />
            </div>
          </div>

          <div className="d-flex justify-content-center mt-4">
            <Button
              type="submit"
              disable={isSubmitting}
              buttonStyleType="solid"
              content={isSubmitting ? Lang.isSaving : Lang.save}
              containerStyle="col-2 mx-3"
            />

            <Button
              type="button"
              onClick={() => setShow(false)}
              content={Lang.cancel}
              containerStyle="col-2 mx-3"
            />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ResponseForm;
